import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const LanguageDefaultSvg = ({ size = 24 }) => (
  <SvgWrapper size={size}>
    <path
      d="M12.2054 20.8696L16.9183 10.0889L21.7706 21.2748"
      stroke="#D7E0EE"
      strokeWidth="2.99202"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1075 18.8055H20.6987"
      stroke="#D7E0EE"
      strokeWidth="2.99202"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.46893 9.87492C4.46893 9.87492 6.62444 14.0076 10.3099 15.5797"
      stroke="#D7E0EE"
      strokeWidth="2.99202"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.25668 15.5787C3.25668 15.5787 8.73458 12.749 10.083 6.50617"
      stroke="#D7E0EE"
      strokeWidth="2.99202"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.6024 3.31765V5.9237"
      stroke="#D7E0EE"
      strokeWidth="2.99202"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 6.50682L11.4747 6.49069"
      stroke="#D7E0EE"
      strokeWidth="2.99202"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgWrapper>
)
